<div id="template" style="height: auto; min-height: 100vh;">
    <div style="position: sticky; top: 0; z-index: 1000; width: 100%; background: white; margin-bottom: 0px;">
        <swipesum-header appName="CPO Suite" homeLink="/">
            <div primary-navigation style="width: 100%;">
                <div style="display: flex; width: 100%; justify-content: flex-end; gap: 30px;">
                    <div style="font-size:.9em; display: flex; align-items: center;">
                        <button type="button" class="header-text-button" (click)="onDocumentationClick()">documentation</button>
                    </div>
                    <div style="font-size:.9em; display: flex; align-items: center; margin-right: 20px;">
                        <button type="button" class="header-text-button" (click)="onLoginClick()">login</button>
                    </div>
                </div>
            </div>
        </swipesum-header>
    </div>
    @if (windowLocation === '/sign-in') {
        <!-- Notification to reset password -->
        <div style="display: flex; align-items: center; justify-content: center; gap: 10px; background-color: rgb(255, 78, 78); color: white; padding: 10px; text-align: center;">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm330.5-51.5Q520-263 520-280t-11.5-28.5Q497-320 480-320t-28.5 11.5Q440-297 440-280t11.5 28.5Q463-240 480-240t28.5-11.5ZM440-360h80v-200h-80v200Zm40-100Z"/></svg>
            <p>If you have not logged in since October 4th, 2026, please reset your password.</p>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm330.5-51.5Q520-263 520-280t-11.5-28.5Q497-320 480-320t-28.5 11.5Q440-297 440-280t11.5 28.5Q463-240 480-240t28.5-11.5ZM440-360h80v-200h-80v200Zm40-100Z"/></svg>
        </div>
    }

    <div id="content"> 
        <div style="padding:10px;">
            <router-outlet></router-outlet>
        </div>
    </div>

    <swipesum-footer appName="CPO Suite"></swipesum-footer>
</div>